const productPayment = {
    successTitle: 'Betaling voltooid!',
    successMessage: 'Je bestelling is ontvangen en bevestigd',
    nextSteps: 'Volgende Stappen',
    emailConfirmation: 'Je ontvangt een bevestigingse-mail',
    orderProcessing: 'Je bestelling wordt verwerkt',
    shippingUpdate: 'Je ontvangt updates over de verzending',
    viewOrders: 'Bekijk Bestellingen',
    continueShopping: 'Doorgaan met Winkelen',
    questions: 'Vragen?',
    contactUs: 'Neem Contact Op',
    cancelledTitle: 'Betaling Geannuleerd',
    cancelledMessage: 'Je betaling is geannuleerd',
    whatHappened: 'Wat is er gebeurd?',
    noCharge: 'Er is geen bedrag in rekening gebracht',
    cartPreserved: 'Je producten staan nog in je winkelwagen',
    tryAgain: 'Probeer Opnieuw',
    returnToCart: 'Terug naar Winkelwagen',
    needHelp: 'Heb je hulp nodig?'
};

export default productPayment;

